<div layout="row" layout-align="center" layout-padding flex>
  <img
    src="http://www.motorolasolutions.com/content/dam/msi/images/business/products/accessories/_images/_staticfiles/b2b_product_placeholder_lg_us-en.jpg"
    style="width: 168px; height: 168px">
</div>
